export default [
  {
    title: 'Ecoassist',
    content:
      'Trabalhar com a Dynamic nos traz tranquilidade. A equipe atua com auto grau de profissionalismo. Os dashboards desenvolvidos para nossa operação facilitam a gestão do dia a dia. Fizemos alguns trabalhos e, certamente, faremos outros. Temos que valorizar bons prestadores e construir uma relação duradoura.',
    customerName: 'Eber Souza',
    customerTitle: 'Marketing, Produto e Operações na EcoAssist',
    customerImage: 'https://raichu-uploads.s3.amazonaws.com/logo_ecoassist-servicos-sustentaveis_f4lYYs.png'
  },
  {
    title: 'VIP Promotora de Crédito',
    content:
      'Conheci a Dynamic quando precisei de uma solução sob medida no Excel. Contactei a empresa e desde então muitos outros projetos surgiram. Uma parceria que traz solução a muitas áreas da tecnologia. Recomendo completamente os serviços.',
    customerName: 'Rafael Mengue',
    customerTitle: 'Gerente na VIP Promotora de Crédito',
    customerImage: 'https://lh4.googleusercontent.com/-A2_aqZH1nlc/AAAAAAAAAAI/AAAAAAAAAAA/OBaDi6x1APs/s44-p-k-no-ns-nd/photo.jpg'
  },
  {
    title: 'Disruptec Brasil',
    content:
      'Se eu pudesse resumir a Dynamic em uma palavra ela seria, solução! Eles são especialistas em resolver problemas.',
    customerName: 'Ayrton Meira',
    customerTitle: 'Disruptec Brasil',
    customerImage: 'https://disruptec.com.br/wp-content/uploads/2024/02/cropped-favicon-192x192.png'
  }
];
